// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-fit-content[data-v-b73d82e8] {\n  flex: 1 1 auto;\n  margin-bottom: 1rem;\n  padding: 0px 1.25rem;\n}\n.form-group-row[data-v-b73d82e8] {\n  gap: 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.form-group-row label[data-v-b73d82e8] {\n  margin-bottom: 0px;\n}\n.switch[data-v-b73d82e8] {\n  margin: 1rem 1.25rem;\n  margin-top: 0px;\n}", ""]);
// Exports
module.exports = exports;
